import React, { Component } from 'react';
import CustomModal from "../../../components/Modal/CustomModal";
import { toast } from 'react-toastify';

import { delRequisito } from "../../../funciones/AdmisionFunction";

class RequisitoTable extends Component {
    state = {
        button1: "fa fa-edit",
        button2: "fa fa-trash",
        openDelReg: false,
        botonSi: <span>Si</span>,
    }

    componentWillReceiveProps = () => {
        this.setState({openDelReg: false})
    }

    modalDelReq = () => {
        let { botonSi, openDelReg } = this.state;

        let contenidoModal = <div>
            ¿Desea realmente <strong>Este Requisito</strong> de la Base de Datos?
            <div style={{fontSize:10}}>Esta opción no puede deshacerse</div>
        </div>

        return(
            <CustomModal
                backgroundColor= {"#1f2f6e"}
                isopen =  {openDelReg}
                titulo = {<div style={{color:"#FFF"}}>Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {botonSi}
                boton2 = "No"
                funcion1 = { () => {
                    this.setState({
                        botonSi: <span><i className="fa fa-spinner fa-spin"></i> Espera</span>
                    }, () => {
                        delRequisito (this.props.datos.id, () => {
                            this.setState({
                                openDelReg: false,
                                botonSi: <span>Si</span>,
                            }, () => {
                                toast.info("Se ha eliminado correctamente el requisito de la Base de Datos",{autoClose: 4000});
                                this.props.updListado()
                            })
                        })
                    })
                }}
            />
        )
    }

    openModalReq = () => {
        this.setState({openDelReg: true})
    }

    render() {
        let { datos } = this.props;
        let { button1, button2 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <React.Fragment>
                <tr>
                    <td align="left" style={styles}>{datos.requisito_desc}</td>
                    <td align="center" style={styles}>
                        <div className="btn-group">
                            <button style={{borderWidth: 1}} onClick = {() => {this.props.funcionEdit(datos.id, datos.requisito_desc)}} title= "Editar este requisito" className="btn btn-sm btn-warning"><i className={button1}></i></button>
                            <button style={{borderWidth: 1}} onClick= {this.openModalReq} title= "Eliminar este requisito" className="btn btn-sm btn-danger"><i className={button2}></i></button>
                        </div>
                    </td>
                </tr>
                {this.modalDelReq()}
            </React.Fragment>
        );
    }
}
 
export default RequisitoTable;


// WEBPACK FOOTER //
// ./src/views/Registros/PreferenciasContent/RequisitoTable.jsx